import { render, staticRenderFns } from "./ProjectListAndCard.vue?vue&type=template&id=6500928e"
import script from "./ProjectListAndCard.vue?vue&type=script&lang=js"
export * from "./ProjectListAndCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports